import Commander from "./Commander";
import {pixiSetTimeout} from "../framework/src/engine/pixi/pixiTimeout";
import * as PIXI from "pixi.js-legacy";

export default class NormalWin {

    constructor (commander) {
        this.commander = commander;
        this.BlinkAnimation = this.commander.BlinkAnimation;
        this.WinCounter = this.commander.WinCounter;
        this.logo = undefined;

        this.layer = this.commander.layers.win;

        this.lights = new PIXI.Container();
        this.lights.name = 'lights';
        this.winPositions = [
            [false, false, false, false],
            [false, false, false, false],
            [false, false, false, false],
            [false, false, false, false],
            [false, false, false, false]
        ];

        this.grid = new PIXI.Container();
        this.grid.position.set(0,-150);
        this.grid.addChild(Commander.getSprite('background_lines.png', 640, 0, {x:.5, y: .0}));
        this.grid.addChild(this.lights);
        this.grid.name = 'grid';
        this.layer.addChild(this.grid);
    }

    init() {
        this.initWinPositions();
        this.initLines();
        this.initFrames();
        this.Freespins = this.commander.Freespins;
    }

    initWinPositions() {
        let X = [595, 618, 640, 664, 686];
        let Y = [20, 37, 56, 74];
        for (let x = 0; x < 5; x++) {
            for (let y = 0; y < 4; y++) {
                let light = Commander.getSprite('lines_light.png', X[x], Y[y]);
                light.visible = false;
                this.lights.addChild(light);
            }
        }
    }

    initLines () {
        this.lines = new PIXI.Container();
        this.lines.name = 'frames';
        let layer = this.commander.layers.lines;

        for (let line of this.commander.gameset.game.lines) {
            let sprite = Commander.getSprite(line.name, line.position.x, line.position.y, {x: .5, y: .5});
            sprite.scale.set(line.scale.x, line.scale.y);
            sprite.visible = false;
            this.lines.addChild(sprite);
        }
        layer.addChildAt(this.lines,0);

        this.mask = new PIXI.Graphics();
        this.mask.beginFill(0x0000, 1);
        this.mask.moveTo(0,0);
        this.mask.lineTo(1280, 0);
        this.mask.lineTo(1280, 720);
        this.mask.lineTo(0, 720);
        // this.mask.drawRect(0,0, 1280, 720);
        this.mask.endFill();

        this.lines.mask = this.mask;
    }

    initFrames() {
        this.frames = new PIXI.Container();
        this.frames.name = 'frames';
        let X = [205, 423, 640, 857, 1075];
        let Y = [140, 280, 420, 560];
        for (let col = 0; col < 5; col++) {
            for (let row = 0; row < 4; row++) {
                let frame = Commander.getSprite('frame.png', X[col], Y[row]);
                frame.visible = false;
                this.frames.addChild(frame);
            }
        }
        this.layer.addChildAt(this.frames,0);
    }

    async run(result, oldWin) {
        return new Promise(async res => {
            this.hideLogo();
            this.showGrid();
            this.BlinkAnimation.blinkFrames();
            this.WinCounter.normal(
                result.lineWins.length * 150,
                result.win - oldWin,
                res
            );  // end current promise after the WinCounter disappears

            for (let line of result.lineWins) {
                if (line.type === "freeSpins") break;
                if (!this.commander.skipAnim) {
                    this.lineAnim(line);
                    await new Promise(resolve => setTimeout(resolve, 150)).then(() => {
                        this.lineAnimEnd(line);
                    });
                }
                this.commander.lineWinsIndex++;
            }

            if (this.commander.skipAnim) {
                if (this.commander.freespins.isInFreeSpins()) {
                    this.Freespins.showCounter();
                } else {
                    this.showLogo();
                }
            }

            if (this.commander.freespins.isInFreeSpins()) {
                this.Freespins.showCounter();
            } else {
                this.showLogo();
            }
            this.hideGrid();
        });
    }

    lineAnim(line) {
        this.hideLights();
        this.setWinPositions(line.position);
        this.setMaskWidth(line.position.length);
        this.drawFrames(); // this function also runs blink animations on win symbols
        this.showLine(line.line);
        this.showLights(line.line);
    }

    showLights(line) {
        const lines = [
            [1,5, 9,13,17], [2,6,10,14,18], [0,4, 8,12,16], [3,7,11,15,19],
            [2,5, 8,13,18], [1,6,11,14,17], [1,4, 8,12,17], [2,7,11,15,18],
            [0,5,10,15,19], [3,6, 9,12,16], [1,5,10,13,17], [2,6, 9,14,18],
            [0,4, 9,12,16], [3,7,10,15,19], [1,5,10,14,17], [2,6, 9,13,18],
            [0,4, 8,13,16], [3,7,11,14,19], [0,5,10,13,16], [3,6, 9,14,19],
            [0,4, 9,13,16], [3,7,10,14,19], [0,5, 8,13,16], [3,6,11,14,19],
            [1,6,10,13,17], [2,5, 9,14,18], [1,4, 9,12,17], [2,7,10,15,18],
            [0,5, 9,13,16], [3,6,10,14,19], [1,6, 9,12,17], [2,5,10,15,18],
            [0,4, 9,14,19], [3,7,10,13,16], [0,5, 9,12,16], [3,6,10,15,19],
            [0,4, 8,13,18], [3,7,11,14,17], [1,4, 8,12,16], [2,7,11,15,19]
        ];
        this.lights.children[lines[line][0]].visible = this.lights.children[lines[line][1]].visible = true;
        this.lights.children[lines[line][2]].visible = this.lights.children[lines[line][3]].visible = true;
        this.lights.children[lines[line][4]].visible = true;
    }

    hideLights() {
        for (let light of this.lights.children)
            light.visible = false;
    }

    lineAnimEnd(line) {
        this.hideLights();
        this.resetWinPositions();
        this.hideFrames();
        this.hideLine(line.line);
        this.showFrames();
        this.BlinkAnimation.clearTargetFilters();
    }

    showLine(number) {
        this.lines.children[number].visible = true;
    }

    hideLines() {
        for (let i = 0; i < this.lines.children.length; i++) {
            this.hideLine(i);
        }
    }

    hideLine(number) {
        this.lines.children[number].visible = false;
    }

    hideFrames() {
        for (let i = 0; i < this.frames.children.length; i++) {
            this.hideFrame(i);
        }
    }

    hideFrame(number) {
        this.frames.children[number].visible = false;
    }

    showFrames() {
        for (let x = 0; x < 5; x++) {
            for (let y = 0; y < 4; y++) {
                if (this.winPositions[x][y]) {
                    this.showFrame(x * 4 + y);
                }
            }
        }
    }

    showFrame(number) {
        this.frames.children[number].visible = true;
    }

    showAllWinPositions(result) {
        this.setAllWinPositions(result);
        for (let x = 0; x < 5; x++) {
            for (let y = 0; y < 4; y++) {
                this.lights.children[x*4+y].visible = this.winPositions[x][y];
            }
        }
    }

    setAllWinPositions(result) {
        for (let line of result.lineWins) {
            this.setWinPositions(line.position);
        }
    }

    drawFrames() {
        let resSymbols = this.commander.slots.getResultSymbols();
        for (let x = 0; x < 5; x++) {
            for (let y = 0; y < 4; y++) {
                if (this.winPositions[x][y]) {
                    this.showFrame(x * 4 + y);
                    this.BlinkAnimation.addTarget(resSymbols[x*4+y]);
                }
            }
        }
    }

    setWinPositions(positions) {
        for (let pos of positions) {
            this.winPositions[pos[0]][pos[1]] = true;
        }
    }

    resetWinPositions() {
        this.winPositions = [
            [false, false, false, false],
            [false, false, false, false],
            [false, false, false, false],
            [false, false, false, false],
            [false, false, false, false]
        ];
    }

    setLogo(logo) {
        this.logo = logo;
    }

    hideLogo() {
        Commander.removeTween(this.logo);
        createjs.Tween.get(this.logo)
            .to({x: 450, y: -100}, 700, createjs.Ease.cubicOut)
            .call(() => {
                Commander.removeTween(this.logo);
            })
    }

    showLogo() {
        Commander.removeTween(this.logo);
        createjs.Tween.get(this.logo)
            .to({x: 450, y: 0}, 700, createjs.Ease.cubicOut)
            .call(() => {
                Commander.removeTween(this.logo);
            })
    }

    showGrid() {
        Commander.removeTween(this.grid);
        createjs.Tween.get(this.grid)
            .to({x: 0, y: 0}, 700, createjs.Ease.cubicOut)
            .call(() => {
                Commander.removeTween(this.grid);
            });
    }

    hideGrid() {
        Commander.removeTween(this.grid);
        createjs.Tween.get(this.grid)
            .to({x: 0, y: -150}, 700, createjs.Ease.cubicOut)
            .call(() => {
                Commander.removeTween(this.grid);
            })     ;
    }

    setMaskWidth(length) { // 3 => w745, 4 => w965, 5 =>
        switch(length) {
            case 3:
                this.mask.clear();
                this.mask.beginFill(0x0000, 1);
                this.mask.moveTo(745,0);
                this.mask.lineTo(1280, 0);
                this.mask.lineTo(1280, 720);
                this.mask.lineTo(745, 720);
                this.mask.closePath();
                // this.mask.width = 535;
                // this.mask.x = 745;
                break;
            case 4:
                this.mask.clear();
                this.mask.beginFill(0x0000, 1);
                this.mask.moveTo(965,0);
                this.mask.lineTo(1280, 0);
                this.mask.lineTo(1280, 720);
                this.mask.lineTo(965, 720);
                this.mask.closePath();
                // this.mask.width = 315;
                // this.mask.x = 965;
                break;
            default:
                this.mask.clear();
                // this.mask.width = 0;
                break;
        }
    }

    shakeSymbols(result) {
        return new Promise(res => {
            this.setAllWinPositions(result);

            let resSymbols = this.commander.slots.getResultSymbols();

            for (let x = 0; x < 5; x++) {
                for (let y = 0; y < 4; y++) {
                    if (!resSymbols[x*4+y]) continue
                    if (this.winPositions[x][y]) {
                        if (resSymbols[x*4+y].name.replace("_blur","") !== "symbol_Joker")
                            this.shake(resSymbols[x*4+y], 10, 1000);
                    } else {
                        resSymbols[x*4+y].tint = 0xAAAAAA;
                    }
                }
            }
            pixiSetTimeout(1, () => {
                this.resetWinPositions();
                res();
            });
        });
    }

    symbolTint(val) {
        let resSymbols = this.commander.slots.getResultSymbols();
        for (let symbol of resSymbols) {
            symbol.tint = val;
        }
    }

    async shake(symbol, count, time) {
        let x = symbol.x;
        let y = symbol.y;
        let power = Math.random() % 2 ? 1 / 3 : -1 / 3;
        for (let i = 0; i < count; i++) {
            await Commander.getTweenAsync(symbol, {
                x: x + (power * 5),
                y: y + ((Math.random() * 10 - 5) * power)
            }, (time / count) / 2);
            // if last loop, return symbol to init position
            await Commander.getTweenAsync(symbol, {
                x: i === count-1 ? x : x - (power * 5),
                y: i === count-1 ? y : y - ((Math.random() * 10 - 5) * power)
            }, (time / count) / 2);
        }
    }
}